import {nationality,parentLanguage, ethnicity, roleName, areaCn,areaEn,districtEn,districtCn,operationType,applicationStatus,applicationStage,eventType,grade,formTo,religion,placeBirth,district,area} from '@/biz/static-data'
import store from '@/store'
import { getUserInfo,getToken } from '@/utils/auth'
export const mixin = {
  data() {
    return {
      isDev:true,
      userInfo:getUserInfo(`userInfo/${store.getters.authorityRoute}`),
      nationality: [],
      religion: [],
      placeBirth: [],
      district: [],
      districtEn: [],
      districtCn: [],
      area: [],
      areaCn: [],
      areaEn: [],
      formTo: [],
      grade: [],
      parentLanguage: [],
      ethnicity: [],
      applicationStage: [],
      applicationStatus: [],
      eventType: [],
      operationType: [],
      sendType: [
        {
          label:"Announcement & Email",
          value:1
        },
        {
          label:"Announcement Only",
          value:2
        },
        {
          label:"Email Only",
          value:3
        },
      ],
      userStatus: [
        {
            label:'Active',
            value:0,
        },
        {
            label:'Inactive',
            value:1,
        },
      ],
      userRoleId: [
        {
          label:'Admin',
          value:1
        },
        {
          label:'Applicant',
          value:2
        },
        {
          label:'Manager',
          value:3
        },
        {
          label:'Clerk',
          value:4
        },
      ],
      userRoleSearch: [
        {
          label:'Admin',
          value:1
        },
        {
          label:'Applicant',
          value:2
        },
        {
          label:'Manager',
          value:3
        },
        {
          label:'Clerk',
          value:4
        },
      ],
      authorityRoute:'',
      roleAdminId:roleName.admin,
      roleManagerId:roleName.manager,
      roleClerkId:roleName.clerk,
      roleApplicantId:roleName.applicant,
      
    }
  },
  created(){
     this.parentLanguage = parentLanguage
     this.ethnicity = ethnicity
     this.nationality = nationality
     this.applicationStatus = applicationStatus
     this.applicationStage = applicationStage
     this.religion = religion
     this.placeBirth = placeBirth
     this.district = district
     this.districtCn = districtCn
     this.districtEn = districtEn
     this.area = area
     this.areaCn = areaCn
     this.areaEn = areaEn
     this.formTo = formTo
     this.grade = grade
     this.eventType = eventType
     this.operationType = operationType
     this.setUserRoleId()
  },
  methods: {
    
    setUserRoleId(){
      if(getToken(store.getters.authorityRoute)){
         if(this.userInfo.roleId == this.roleManagerId){
           this.userRoleSearch= [
            {
              label:'Applicant',
              value:2
            },
            {
              label:'Clerk',
              value:4
            },
          ]
         } else if(this.userInfo.roleId == this.roleClerkId){
              this.userRoleSearch= [
                {
                  label:'Applicant',
                  value:2
                },
              ]
         }
      }
    },
    onBack() {
      this.$router.go(-1)
    },
  }
}
